import { LocalStoreType } from "../constants/local-type";
import { getDataLocal } from "../Helper/localStoreFunction";

export const GetDepartment = async () => {
  const respone = await fetch("api/Department/GetAll")
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {});
  return respone;
};

export const UpdateDepartment = async (dataJson: any) => {
  const email = getDataLocal(LocalStoreType.email) || "";
  dataJson.UserPrincipalName = email;
  const data = {
    name: "Department",
    model: JSON.stringify(dataJson),
  };
  const respone = await fetch("api/Department/AddDepartment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((response) => response.json());
  console.log(respone);

  return respone;
};
